import { render } from "./Accountants.vue?vue&type=template&id=57868c66&scoped=true"
import script from "./Accountants.vue?vue&type=script&lang=js"
export * from "./Accountants.vue?vue&type=script&lang=js"

import "./Accountants.vue?vue&type=style&index=0&id=57868c66&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57868c66"]])

export default __exports__